import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-image-viewer-controls',
  templateUrl: './image-viewer-controls.component.html',
  styleUrls: ['./image-viewer-controls.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, TooltipDirective, SvgComponent, TranslatePipe],
})
export class ImageViewerControlsComponent {
  @Input() scalePercent: number;
  @Input() fitButton: 'width' | 'height';
  @Output() scale = new EventEmitter();

  doScale(e: string, event: MouseEvent) {
    if (event['pointerId'] < 0) return; // prevent space and enter from triggering the button when it is focused
    this.scale.emit(e);
  }
}
